import { useStorage } from "app/custom-hooks/storage/useStorage";
import ConversionRateBanner from "app/pages/sales-intelligence/common-components/feature-upgrade/components/ConversionRate";
import { leadsSearchSessionStorage } from "app/pages/sales-intelligence/modules/leads-search/services/storage";

export const ConversionRateUpgradeView = () => {
    const [isSubmitted, setSubmitted] = useStorage<boolean>(
        leadsSearchSessionStorage.conversionRateFilterHookSubmitted,
    );

    return (
        <ConversionRateBanner
            variant="search"
            isSubmitted={isSubmitted}
            onSubmit={() => setSubmitted(true)}
        />
    );
};
